import * as React from 'react'
import makeCountdown from '../../properties/makeCountdown'

type Props = {
    days: number
    hours: number
    minutes: number
    seconds: number
}

class PopupCountdownTimer extends React.Component<Props> {
    render() {
        const { minutes, seconds } = this.props
        const format = new Intl.NumberFormat('en-AU', { style: 'decimal', minimumIntegerDigits: 2 }).format

        return (
            <table>
                <tbody>
                    <tr className='popup-card__countdown__numbers'>
                        <td>{format(minutes)}</td>
                        <td>:</td>
                        <td>{format(seconds)}</td>
                    </tr>
                    <tr className='popup-card__countdown__text'>
                        <td>M</td>
                        <td />
                        <td>S</td>
                    </tr>
                </tbody>
            </table>
        )
    }
}

export default makeCountdown(PopupCountdownTimer)
